import DOMPurify from 'dompurify';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { IMailMessageParty } from "../interfaces/IDealMailMessage";
import { formatDateTime } from "../utils/utils";
import Spinner from './spinners/Spinner';
import styles from './Email.module.css';

function Email({ subject, from, to, snippet, body, hasBodyFlag, messageTime, onExpand }: IEmailProps) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isBodyLoading, setIsBodyLoading] = useState(false);

    const hasBody = hasBodyFlag === 1;
    const fromText = formatParties(from);
    const toText = formatParties(to);

    const toggle = async () => {
        if (!isExpanded && body === undefined && onExpand) {
            setIsBodyLoading(true);
            try {
                await onExpand();
            } finally {
                setIsBodyLoading(false);
            }
        }
        setIsExpanded(value => !value);
    };

    return (
        <div className={styles.container}>
            <div className={styles.title}>{formatDateTime(messageTime)} (Email)</div>
            {subject && <div className={styles.subject}>{subject}</div>}
            {fromText && <div className={styles.party}><span className={styles.partyLabel}>From:</span> {fromText}</div>}
            {toText && <div className={styles.party}><span className={styles.partyLabel}>To:</span> {toText}</div>}
            {isExpanded
                ? <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body || snippet || "") }}></div>
                : <div className={styles.snippet}>{snippet}</div>}
            {hasBody && (
                <button type="button" className={styles.expandButton} onClick={toggle} disabled={isBodyLoading}>
                    {isExpanded ? "Show less" : "Show more"}
                    {isBodyLoading && <Spinner className={styles.spinner} />}
                </button>
            )}
        </div>
    );
}

function formatParties(parties?: IMailMessageParty[]) {
    return parties?.map(p => p.name ? `${p.name} <${p.emailAddress}>` : p.emailAddress).join(", ");
}

export default observer(Email);

interface IEmailProps {
    subject?: string;
    from?: IMailMessageParty[];
    to?: IMailMessageParty[];
    snippet?: string;
    body?: string;
    hasBodyFlag?: number;
    messageTime: Date;
    onExpand?: () => Promise<void>;
}
